import { Fragment, useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../context/ThemeContext";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Dropdown } from "react-bootstrap";
import { createPromoCode } from "../../store/actions/PromoCodeActions";

const createDefaultRules = () => [
  { service_type: "JOB", billed_type: "monthly", is_active: false },
  { service_type: "JOB", billed_type: "yearly", is_active: false },
  { service_type: "DISK", billed_type: "monthly", is_active: false },
  { service_type: "DISK", billed_type: "yearly", is_active: false },
  { service_type: "PREMIUMSUB", billed_type: "monthly", is_active: false },
  { service_type: "PREMIUMSUB", billed_type: "yearly", is_active: false },
];

const formatToISO = (val) => {
  if (!val) return null;
  const d = new Date(val);
  return !Number.isNaN(d.getTime()) ? d.toISOString() : val;
};

const getDateTimeLocalWithDaysOffset = (daysOffset = 0) => {
  const now = new Date();
  if (daysOffset) {
    now.setDate(now.getDate() + daysOffset);
  }
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  return now.toISOString().slice(0, 16);
};

const CreatePromoCode = () => {
  const { changeBackground } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    code: "",
    name: "",
    discount_type: "PERCENTAGE",
    discount_value: "",
    max_redemptions: "",
    max_redemptions_per_user: "",
    start_at: getDateTimeLocalWithDaysOffset(0),
    expires_at: getDateTimeLocalWithDaysOffset(1),
    is_active: true,
    rules: createDefaultRules(),
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const serviceTypes = ["JOB", "DISK", "PREMIUMSUB"];
  const billedTypes = ["monthly", "yearly"];

  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleRuleChange = (serviceType, billedType) => {
    setFormData((prev) => ({
      ...prev,
      rules: prev.rules.map((rule) =>
        rule.service_type === serviceType && rule.billed_type === billedType
          ? { ...rule, is_active: !rule.is_active }
          : rule
      ),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const payload = {
      code: formData.code.trim(),
      name: formData.name.trim(),
      discount_type: formData.discount_type,
      discount_value: formData.discount_value,
      max_redemptions: Number(formData.max_redemptions),
      max_redemptions_per_user: Number(formData.max_redemptions_per_user),
      start_at: formatToISO(formData.start_at),
      expires_at: formatToISO(formData.expires_at),
      is_active: formData.is_active,
      rules: formData.rules,
    };

    try {
      const res = await dispatch(createPromoCode(payload));

      if (res?.payload?.id) {
        toast.success("Promo code created successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
        });
        navigate("/promo-codes");
      } else {
        toast.error(
          res?.payload?.message ||
            "Something went wrong while creating promo code!",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
          }
        );
      }
    } catch (error) {
      toast.error(
        error?.data?.message ||
          error?.data?.detail ||
          error?.message ||
          "Something went wrong while creating promo code!",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
        }
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Fragment>
      <div className="col-12">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title">Create Promo Code</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Code</label>
                  <input
                    type="text"
                    name="code"
                    className="form-control"
                    placeholder="Enter code"
                    value={formData.code}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Enter promo name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Discount Type</label>
                  {/* <select
                    name="discount_type"
                    className="form-control"
                    value={formData.discount_type}
                    onChange={handleChange}
                  >
                    <option value="PERCENTAGE">PERCENTAGE</option>
                    <option value="FIXED">FIXED</option>
                  </select> */}
                  <Dropdown className="w-100">
                    <Dropdown.Toggle
                      variant="light"
                      className="form-control text-start d-flex align-items-center justify-content-between font-w500"
                      id="dropdown-discount-type"
                    >
                      {formData.discount_type}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="w-100">
                      <Dropdown.Item
                        active={formData.discount_type === "PERCENTAGE"}
                        onClick={() =>
                          setFormData((prev) => ({ ...prev, discount_type: "PERCENTAGE" }))
                        }
                      >
                        PERCENTAGE
                      </Dropdown.Item>
                      <Dropdown.Item
                        active={formData.discount_type === "FIXED"}
                        onClick={() =>
                          setFormData((prev) => ({ ...prev, discount_type: "FIXED" }))
                        }
                      >
                        FIXED
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Discount Value</label>
                  <div className="input-group">
                    <input
                      type="number"
                      min="0"
                      step="any"
                      name="discount_value"
                      className="form-control"
                      placeholder={
                        formData.discount_type === "PERCENTAGE"
                          ? "e.g. 10 or 25"
                          : "e.g. 10.00"
                      }
                      value={formData.discount_value}
                      onChange={handleChange}
                      required
                    />
                    {formData.discount_type === "PERCENTAGE" ? (
                      <Dropdown align="end" className="d-flex">
                        <Dropdown.Toggle
                          variant="light"
                          className="border text-dark font-w600 d-flex align-items-center"
                          style={{
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0,
                            backgroundColor: "#f8f9fa",
                            borderColor: "#ced4da",
                            height: "100%",
                          }}
                        >
                          % <span className="small text-muted ms-1">(Select)</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto", zIndex: 1050 }}>
                          {[5, 10, 15, 20, 25, 30, 40, 50, 75, 100].map((val) => (
                            <Dropdown.Item
                              key={val}
                              onClick={() =>
                                setFormData((prev) => ({
                                  ...prev,
                                  discount_value: String(val),
                                }))
                              }
                            >
                              {val}%
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    ) : (
                      <span className="input-group-text font-w600">$</span>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Max Redemptions</label>
                  <input
                    type="number"
                    min="0"
                    name="max_redemptions"
                    className="form-control"
                    placeholder="e.g. 100"
                    value={formData.max_redemptions}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Max Redemptions Per User</label>
                  <input
                    type="number"
                    min="0"
                    name="max_redemptions_per_user"
                    className="form-control"
                    placeholder="e.g. 1"
                    value={formData.max_redemptions_per_user}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Start At</label>
                  <input
                    type="datetime-local"
                    name="start_at"
                    className="form-control"
                    value={formData.start_at}
                    onChange={handleChange}
                    onClick={(e) => e.target.showPicker && e.target.showPicker()}
                    style={{ cursor: "pointer" }}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Expires At</label>
                  <input
                    type="datetime-local"
                    name="expires_at"
                    className="form-control"
                    value={formData.expires_at}
                    onChange={handleChange}
                    onClick={(e) => e.target.showPicker && e.target.showPicker()}
                    style={{ cursor: "pointer" }}
                    required
                  />
                </div>
                <div className="col-12">
                  <div className="form-check form-switch d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      name="is_active"
                      className="form-check-input"
                      id="promoIsActive"
                      checked={formData.is_active}
                      onChange={handleChange}
                      style={{ cursor: "pointer" }}
                    />
                    <label className="form-check-label mb-0" htmlFor="promoIsActive">
                      Active
                    </label>
                  </div>
                </div>
                <div className="col-12 mt-4">
                  <label className="form-label mb-2 font-w600">Rules</label>
                  <div className="table-responsive">
                    <table className="table table-bordered align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Service Type</th>
                          {billedTypes.map((billedType) => (
                            <th key={billedType} className="text-center text-capitalize">
                              {billedType}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {serviceTypes.map((serviceType) => (
                          <tr key={serviceType}>
                            <td className="font-w600 text-dark">{serviceType}</td>
                            {billedTypes.map((billedType) => {
                              const rule = formData.rules.find(
                                (item) =>
                                  item.service_type === serviceType &&
                                  item.billed_type === billedType
                              );

                              return (
                                <td key={`${serviceType}-${billedType}`} className="text-center">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    style={{ width: "20px", height: "20px", cursor: "pointer" }}
                                    checked={rule?.is_active ?? false}
                                    onChange={() =>
                                      handleRuleChange(serviceType, billedType)
                                    }
                                  />
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end gap-2 mt-4">
                <button type="submit" className="btn btn-primary px-4 mt-4" disabled={isSubmitting}>
                  {isSubmitting ? "Saving..." : "Create"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CreatePromoCode;
